<box>
  <box-icon src="assets/svg/ressources/{{ svg }}"></box-icon>

  <box-footer>
    <div class="d-flex align-items-center justify-content-center mt-1">
      <pr-suffix [suffix]="{ title: suffix }"></pr-suffix>
      <span> {{ title }}</span>
    </div>
  </box-footer>
</box>
